import Trimaster from "@/plugins/servers/trimaster";
import store from "@/store";
import vuetifyToast from "@/vuetifyToast";
import {EventBus} from "@/event-bus";

export const FULL_LIST_ACTION_ID = -101
export const HIDE_FULL_LIST_ACTION_ID = -102
export const AUTOMATIC_MODE_ACTION_ID = 83
export const MANUAL_MODE_ACTION_ID = 84
export const VFU_SCHEDULE_ACTION_ID = 0
export const MAINTENANCE_MODE_ACTION_ID = 58
export const CURTAINS_UP_ACTION_ID = 115
export const IMPAIRED_CHILLER_ACTION_ID = 147
export const IPM_APPLICATION_ACTION_ID = 59
export const IPM_LOCK_ACTION_ID = 60
export const LIGHT_ACTION_ID = 61
export const DARK_ACTION_ID = 62
export const STANDBY_ACTION_ID = 89
export const STERILIZE_ACTION_ID = 120
export const FORCE_SYNC_ACTION_ID = 146

export const ALL_LIGHTS_ON_ACTION_ID = 47
export const ALL_LIGHTS_OFF_ACTION_ID = 48
export const SET_INTENSITY_ACTION_ID = 90
export const IRRIGATE_ACTION_ID = 16
export const STOP_ALL_IRRIGATION_ACTION_ID = 17
export const CALIBRATE_CO2_ACTION_ID = 92
export const ASSIGN_CONTROL_LOOPS_ACTION_ID = 87
export const UPDATE_HOST_NAME_ACTION_ID = 139
export const UPGRADE_FIRMWARE_ACTION_ID = 136
export const EXECUTE_BASH_COMMAND_ACTION_ID = 145
export const MOVE_RACK_ACTION_ID = -100
export const DEBUG_MODE_ON_ACTION_ID = 104
export const DEBUG_MODE_OFF_ACTION_ID = 105
export const REFRESH_SOIL_READINGS_ACTION_ID = 141
export const UPGRADE_CLIENT_ACTION_ID = 138
export const UPGRADE_OS_ACTION_ID = 137
export const RELOAD_LIFECYCLES_ACTION_ID = 51
export const RESTART_CONTROLLER_ACTION_ID = 103
export const LOG_HARDWARE_STATES_ACTION_ID = 152
export const SERVICE_MODE_ACTION_ID = 153
export const ASSIGN_PLATFORM_GROUP_COLLECTION_ACTION_ID = -103
export const UNASSIGN_PLATFORM_GROUP_COLLECTION_ACTION_ID = -104

export const ecuStateColors = {
  cooling: "blue",
  cooling2: "#000080",
  heat: "#ffa500",
  heating2: "#b30000",
  heating3: "#660000",
  dehumidifying: "purple",
  dehumheating: "#FF00FF",
  humidifying: "blue-grey",
  circulating: "#FFA726",
  off: "gray",
  fan: "#FFA726",
  low_circulate: "#FFCC80"
}

const loadOperationActions = (forceLoadActionId = null) => {
  return new Promise((resolve, reject) => {
    let fullList = [
      {
        id: "-4",
        label: "OPERATION",
        disabled: true,
        value: "-4",
        header: "OPERATION",
      },
      {
        id: AUTOMATIC_MODE_ACTION_ID,
        label: "Set mode to Automatic",
        value: "SetAutomatic",
        group: "OPERATION",
      },
      {
        id: MANUAL_MODE_ACTION_ID,
        label: "Set mode to Manual",
        value: "SetManual",
        group: "OPERATION",
      },
      {
        id: VFU_SCHEDULE_ACTION_ID,
        label: "Set VFU Schedule",
        value: "SetManual",
        group: "OPERATION",
      },
      {
        id: SERVICE_MODE_ACTION_ID,
        label: "Set mode to Service",
        value: "SetService",
        group: "OPERATION",
      },
      {
        id: MAINTENANCE_MODE_ACTION_ID,
        label: "Set mode to Maintenance",
        value: "Maintenance",
        group: "OPERATION",
        fullListOnly: true,
      },
      {
        id: CURTAINS_UP_ACTION_ID,
        label: "Set mode to Curtains Up",
        value: "RCUCurtainsUp",
        group: "OPERATION",
        fullListOnly: true,
      },
      {
        id: IMPAIRED_CHILLER_ACTION_ID,
        label: "Set mode to Impaired Chiller",
        value: "ImpairedChill",
        group: "OPERATION",
      },
      {
        id: IPM_APPLICATION_ACTION_ID,
        label: "IPM Application",
        value: "IPMApplication",
        deviceTypeId: 15,
        group: "OPERATION",
        fullListOnly: true,
      },
      {
        id: IPM_LOCK_ACTION_ID,
        label: "IPM Lock",
        value: "IPMLock",
        deviceTypeId: 15,
        group: "OPERATION",
        fullListOnly: true,
      },
      {
        id: LIGHT_ACTION_ID,
        label: "Set mode to Light",
        value: "Light",
        group: "OPERATION",
        fullListOnly: true,
      },
      {
        id: DARK_ACTION_ID,
        label: "Set mode to Dark",
        value: "Dark",
        group: "OPERATION",
        fullListOnly: true,
      },
      {
        id: STANDBY_ACTION_ID,
        label: "Set mode to Standby",
        value: "Standby",
        group: "OPERATION",
        fullListOnly: true,
      },
      {
        id: STERILIZE_ACTION_ID,
        label: "Begin Sterilize State",
        value: "Sterilize",
        group: "OPERATION",
        fullListMode: (store.getters['getUser'].facility.dashboardUIVersion === 1 && forceLoadActionId !== HIDE_FULL_LIST_ACTION_ID)
         || forceLoadActionId === FULL_LIST_ACTION_ID
      },
      {
        id: FORCE_SYNC_ACTION_ID,
        label: "Force Sync",
        value: "ForceSync",
        group: "OPERATION",
        fullListOnly: true,
      },
    ]
    let actions = fullList
    if (
      forceLoadActionId === HIDE_FULL_LIST_ACTION_ID
      || (forceLoadActionId !== FULL_LIST_ACTION_ID && store.getters['getUser'].facility.dashboardUIVersion > 1)
    ) {
      actions = fullList.filter(action => !action.fullListOnly)
    }
    resolve(actions);
  });
}

const loadCO2Actions = () => {
  return new Promise((resolve, reject) => {
    resolve([
      {
        id: "-9",
        label: "CO2",
        disabled: true,
        value: "-9",
        header: "CO2",
      },
      {
        id: 85,
        label: "Enable CO2",
        value: "CO2Enable",
        deviceTypeId: 18,
        deviceType: "CO2",
        group: "OPERATION",
      },
      {
        id: 86,
        label: "Disable CO2",
        value: "CO2Disable",
        deviceTypeId: 18,
        deviceType: "CO2",
        group: "OPERATION",
      },
    ])
  })
}

const loadTemperatureActions = (forceLoadActionId) => {
  let ecuActionsPromise = Trimaster.get(
    "virtualDeviceTypes/18", // ECU Device Type
    store.getters['getUser'].apitoken,
    {
      filter: {
        include: [{relation: "actions"}],
      }
    }
  );
  let bardActionsPromise = Trimaster.get(
    "virtualDeviceTypes/39", // BARD Device Type
    store.getters['getUser'].apitoken,
    {
      filter: {
        include: [{relation: "deviceTypeActions"}],
      }
    }
  );
  return Promise.all([
    ecuActionsPromise,
    bardActionsPromise,
  ]).then((responses) => {
    let ecuDeviceType = responses[0][0] ? responses[0][0] : [];
    let bardDeviceType = responses[1][0] ? responses[1][0] : [];
    let ecuActions = ecuDeviceType.actions.map(ecuAction => {
      const color = ecuStateColors[ecuAction.stateName.toLowerCase()]
      return {
        id: ecuAction.action_id,
        label: "ECU - " + ecuAction.actionDisplayName,
        value: ecuAction.actionName,
        deviceType: "ECU",
        deviceTypeId: 18,
        group: "TEMPERATURE",
        icon: 'air',
        iconColor: color ?? ''
      }
    });
    let bardActions = bardDeviceType.deviceTypeActions.map(ecuAction => {
      return {
        id: ecuAction.id,
        label: "BARD - " + ecuAction.displayName,
        value: ecuAction.name,
        deviceType: "Bard",
        deviceTypeId: 39,
        group: "TEMPERATURE",
      }
    });
    ecuActions.sort((a, b) => {
      return a.label < b.label ? -1 : 1;
    });
    bardActions.sort((a, b) => {
      return a.label < b.label ? -1 : 1;
    });
    let temperatureActions = [
      {
        id: "-2",
        label: "TEMPERATURE",
        disabled: true,
        value: "-2",
        header: "TEMPERATURE",
      },
      ...ecuActions
    ];
    if (
      forceLoadActionId === HIDE_FULL_LIST_ACTION_ID
      || (forceLoadActionId !== FULL_LIST_ACTION_ID && store.getters['getUser'].facility.dashboardUIVersion > 1)
    ) {
      return temperatureActions
    } else {
      return [
        ...temperatureActions,
        ...bardActions
      ]
    }
  });
}

const loadHumidifierActions = (forceLoadActionId) => {
  return new Promise((resolve, reject) => {
    let fullList = [
      {
        id: "-7",
        label: "HUMIDITY",
        disabled: true,
        value: "-7",
        header: "HUMIDITY",
      },
      {
        id: 27,
        label: "Humidifier ON",
        value: "ValveOn",
        deviceType: "VFUHumidifier",
        deviceTypeId: 41,
        group: "HUMIDITY",
      },
      {
        id: 28,
        label: "Humidifier OFF",
        value: "ValveOff",
        deviceType: "VFUHumidifier",
        deviceTypeId: 41,
        group: "HUMIDITY",
      },
      {
        id: 125,
        label: "Dehumidifier 1 ON",
        value: "TwoStageDehumidifierOn1",
        deviceType: "TwoStageDehumidifier",
        deviceTypeId: 43,
        group: "HUMIDITY",
      },
      {
        id: 126,
        label: "Dehumidifier 2 ON",
        value: "TwoStageDehumidifierOn2",
        deviceType: "TwoStageDehumidifier",
        deviceTypeId: 43,
        group: "HUMIDITY",
      },
      {
        id: 127,
        label: "Both Dehumidifiers ON",
        value: "TwoStageDehumidifierOn",
        deviceType: "TwoStageDehumidifier",
        deviceTypeId: 43,
        group: "HUMIDITY",
      },
      {
        id: 124,
        label: "Both Dehumidifiers OFF",
        value: "TwoStageDehumidifierOff",
        deviceType: "TwoStageDehumidifier",
        deviceTypeId: 43,
        group: "HUMIDITY",
      }
    ]
    if (
      forceLoadActionId === HIDE_FULL_LIST_ACTION_ID
      || (forceLoadActionId !== FULL_LIST_ACTION_ID && store.getters['getUser'].facility.dashboardUIVersion > 1)
    ) {
      resolve([
        {
          id: "-7",
          label: "HUMIDITY",
          disabled: true,
          value: "-7",
          header: "HUMIDITY",
        },
        {
          id: 127,
          label: "Both Dehumidifiers ON",
          value: "TwoStageDehumidifierOn",
          deviceType: "TwoStageDehumidifier",
          deviceTypeId: 43,
          group: "HUMIDITY",
        },
        {
          id: 124,
          label: "Both Dehumidifiers OFF",
          value: "TwoStageDehumidifierOff",
          deviceType: "TwoStageDehumidifier",
          deviceTypeId: 43,
          group: "HUMIDITY",
        }
      ]);
    }
    resolve(fullList);
  });
}

const loadLightsActions = () => {
  return new Promise((resolve, reject) => {
    resolve([
      {
        id: "-1",
        label: "LIGHTS",
        disabled: true,
        value: "-1",
        header: "LIGHTS",
      },
      {
        id: ALL_LIGHTS_ON_ACTION_ID,
        label: "All Lights On",
        value: "LightOn",
        deviceTypeId: 13,
        group: "LIGHTS",
        disabled: store.getters['getUser'].facility.lockLights
      },
      {
        id: ALL_LIGHTS_OFF_ACTION_ID,
        label: "All Lights Off",
        value: "LightOff",
        deviceTypeId: 13,
        group: "LIGHTS",
        disabled: store.getters['getUser'].facility.lockLights
      },
      {
        id: SET_INTENSITY_ACTION_ID,
        label: "Set Intensity",
        value: "SetIntensity",
        deviceTypeId: 13,
        group: "LIGHTS",
        disabled: store.getters['getUser'].facility.lockLights
      },
    ]);
  });
}

const loadCurtainActions = () => {
  return new Promise((resolve, reject) => {
    let facilityId = store.getters['getUser'].facility_id
    let actions = [
      {
        id: "-10",
        label: "CURTAINS",
        disabled: true,
        value: "0",
        header: "CURTAINS",
      },
      {
        id: 52,
        label: "Curtains Up",
        value: "CurtainOpen",
        deviceTypeId: 17,
        deviceType: "Curtains",
        group: "CURTAINS",
      },
      {
        id: 53,
        label: "Curtains Down",
        value: "CurtainClose",
        deviceTypeId: 17,
        deviceType: "Curtains",
        group: "CURTAINS",
      },
    ]
    if (facilityId === 51) {
      actions = []
    }
    resolve(actions);
  });
}

const loadAirRailsActions = () => {
  return new Promise((resolve, reject) => {
    let facilityId = store.getters['getUser'].facility_id
    let actions = [
      {
        id: "-11",
        label: "AIR RAILS",
        disabled: true,
        value: "0",
        header: "AIR RAILS",
      },
      {
        id: 520,
        label: "Air Rails Off",
        value: "CurtainOpen",
        deviceTypeId: 17,
        deviceType: "Curtains",
        group: "AIR RAILS",
        actionId: 52
      },
      {
        id: 530,
        label: "Air Rails On",
        value: "CurtainClose",
        deviceTypeId: 17,
        deviceType: "Curtains",
        group: "AIR RAILS",
        actionId: 53
      },
    ]
    if (facilityId !== 51) {
      actions = []
    }
    resolve(actions);
  });
}

const loadFansActions = () => {
  return new Promise((resolve, reject) => {
    let actions = [
      {
        id: "-12",
        label: "FANS",
        disabled: true,
        value: "-12",
        header: "FANS",
      },
      {
        id: 117,
        label: "Fans Off",
        value: "SwitchableFanOff",
        deviceTypeId: 40,
        deviceType: "SwitchableFan",
        group: "FANS",
      },
      {
        id: 116,
        label: "Fans On",
        value: "SwitchableFanOn",
        deviceTypeId: 40,
        deviceType: "SwitchableFan",
        group: "FANS",
      },
    ]
    resolve(actions);
  });
}

const loadIrrigationActions = () => {
  return new Promise((resolve, reject) => {
    resolve([
      {
        id: "-3",
        label: "IRRIGATION",
        disabled: true,
        value: "-3",
        header: "IRRIGATION",
      },
      {
        id: IRRIGATE_ACTION_ID,
        label: "Irrigate",
        value: "Irrigate",
        group: "IRRIGATION",
      },
      {
        id: STOP_ALL_IRRIGATION_ACTION_ID,
        label: "Stop all irrigation",
        value: "88",
        group: "IRRIGATION",
      },
    ]);
  });
}

const loadReinitializeActions = (forceLoadActionId) => {
  return new Promise((resolve, reject) => {
    let opts = [
      {
        id: "-5",
        label: "REINITIALIZE",
        disabled: true,
        value: "-5",
        header: "REINITIALIZE",
      },
      {
        id: RELOAD_LIFECYCLES_ACTION_ID,
        label: "Reload Lifecycles",
        value: "ReloadLifecycles",
        group: "REINITIALIZE",
      },
      {
        id: RESTART_CONTROLLER_ACTION_ID,
        label: "Restart Controller",
        value: "ReloadController",
        group: "REINITIALIZE",
      },
      {
        id: CALIBRATE_CO2_ACTION_ID,
        label: "Calibrate CO2 Sensor",
        value: "CalibrateCO2",
        group: "REINITIALIZE",
        fullListOnly: true,
      }
    ];

    if (Trimaster.isAdmin(store.getters['getUser']) || Trimaster.isUserInRole(store.getters['getUser'],'Maintenance')) {
      opts.push({
        id: ASSIGN_CONTROL_LOOPS_ACTION_ID,
        label: "Assign Custom Control Loops",
        value: "AssignControlLoops",
        group: "REINITIALIZE",
        fullListOnly: true,
      });
    }

    let actions = opts
    if (
      forceLoadActionId === HIDE_FULL_LIST_ACTION_ID
      || (forceLoadActionId !== FULL_LIST_ACTION_ID && store.getters['getUser'].facility.dashboardUIVersion > 1)
    ) {
      actions = opts.filter(action => !action.fullListOnly)
    }

    resolve(actions);
  });
}

const loadOrganizationActions = (forceLoadActionId) => {
  return new Promise((resolve, reject) => {
    let opts = [
      {
        id: "-13",
        label: "ORGANIZATION",
        disabled: true,
        value: "-13",
        header: "ORGANIZATION",
      },
      {
        id: ASSIGN_PLATFORM_GROUP_COLLECTION_ACTION_ID,
        label: "Assign to Collection",
        value: "NONE",
        group: "ORGANIZATION",
      },
      {
        id: UNASSIGN_PLATFORM_GROUP_COLLECTION_ACTION_ID,
        label: "Remove From Collection",
        value: "NONE",
        group: "ORGANIZATION",
      },
    ];

    resolve(opts);
  });
}

const loadMonitoringActions = (forceLoadActionId) => {
  return new Promise((resolve, reject) => {
    let fullList = [
      {
        id: "-6",
        label: "MONITORING",
        disabled: true,
        value: "-6",
        header: "MONITORING",
      },
      {
        id: DEBUG_MODE_ON_ACTION_ID,
        label: "Debug Mode On",
        value: "DEBUG",
        group: "MONITORING",
      },
      {
        id: DEBUG_MODE_OFF_ACTION_ID,
        label: "Debug Mode Off",
        value: "NONE",
        group: "MONITORING",
      },
      {
        id: REFRESH_SOIL_READINGS_ACTION_ID,
        label: "Refresh Soil Readings",
        value: "ALL",
        group: "MONITORING",
      },
    ]
    if (
      forceLoadActionId === HIDE_FULL_LIST_ACTION_ID
      || (forceLoadActionId !== FULL_LIST_ACTION_ID && store.getters['getUser'].facility.dashboardUIVersion > 1)
    ) {
      resolve([])
    } else {}
    resolve(fullList);
  });
}

const loadUpgradeActions = (forceLoadActionId) => {
  return new Promise((resolve, reject) => {
    let opts = [];
    if (Trimaster.isAdmin(store.getters['getUser'])) {
      opts = [
        {
          id: "-8",
          label: "INSTALL/UPGRADE",
          disabled: true,
          value: "-8",
          header: "INSTALL/UPGRADE",
        },
        {
          id: UPDATE_HOST_NAME_ACTION_ID,
          label: "Update Hostname",
          value: "NONE",
          contextOnly: true,
          group: "INSTALL/UPGRADE",
        },
        {
          id: UPGRADE_CLIENT_ACTION_ID,
          label: "Upgrade Client",
          value: "NONE",
          group: "INSTALL/UPGRADE",
        },
        {
          id: UPGRADE_FIRMWARE_ACTION_ID,
          label: "Upgrade Firmware",
          value: "NONE",
          group: "INSTALL/UPGRADE",
        },
        {
          id: UPGRADE_OS_ACTION_ID,
          label: "Upgrade OS",
          value: "NONE",
          group: "INSTALL/UPGRADE",
        },
        {
          id: MOVE_RACK_ACTION_ID,
          label: "Move Rack",
          value: "NONE",
          group: "INSTALL/UPGRADE",
        },
        {
          id: EXECUTE_BASH_COMMAND_ACTION_ID,
          label: "Execute Bash Command",
          value: "NONE",
          group: "INSTALL/UPGRADE",
        },
        {
          id: LOG_HARDWARE_STATES_ACTION_ID,
          label: "Log Hardware States",
          value: "LogHardwareStates",
          group: "INSTALL/UPGRADE",
        },

      ];
    }
    if (
      forceLoadActionId === HIDE_FULL_LIST_ACTION_ID
      || (forceLoadActionId !== FULL_LIST_ACTION_ID && store.getters['getUser'].facility.dashboardUIVersion > 1)
    ) {
      resolve([]);
    } else {
      resolve(opts);
    }
  });
}

const loadShowAllActions = (forceLoadActionId = null) => {
  return new Promise((resolve, reject) => {
    let showAllActions = []
    if (Trimaster.isAdmin(store.getters['getUser'])) {
      if (
        forceLoadActionId === HIDE_FULL_LIST_ACTION_ID
        || (forceLoadActionId !== FULL_LIST_ACTION_ID && store.getters['getUser'].facility.dashboardUIVersion > 1)
      ) {
        showAllActions.push({
          id: FULL_LIST_ACTION_ID,
          label: "Show Full List",
          value: FULL_LIST_ACTION_ID,
        })
      } else {
        showAllActions.push({
          id: HIDE_FULL_LIST_ACTION_ID,
          label: "Hide Full List",
          value: HIDE_FULL_LIST_ACTION_ID,
        })
      }
    }
    resolve(showAllActions)
  })
}

export const loadBatchActions = async (forceLoadActionId = null) => {
  return await Promise.all([
    loadOperationActions(forceLoadActionId),
    loadTemperatureActions(forceLoadActionId),
    loadHumidifierActions(forceLoadActionId),
    loadLightsActions(forceLoadActionId),
    loadCurtainActions(forceLoadActionId),
    loadAirRailsActions(forceLoadActionId),
    loadIrrigationActions(forceLoadActionId),
    loadReinitializeActions(forceLoadActionId),
    loadMonitoringActions(forceLoadActionId),
    loadUpgradeActions(forceLoadActionId),
    loadShowAllActions(forceLoadActionId),
    loadCO2Actions(),
    loadFansActions(),
    loadOrganizationActions(),
  ]).then((responses) => {
    let operationActions = responses[0];
    let temperatureActions = responses[1];
    let humidifierActions = responses[2];
    let lightsActions = responses[3];
    let curtainsActions = responses[4];
    let airRailsActions = responses[5];
    let irrigationActions = responses[6];
    let reinitializeActions = responses[7];
    let monitoringActions = responses[8];
    let upgradeActions = responses[9];
    let showAllActions = responses[10];
    let co2Actions = responses[11];
    let fansActions = responses[12];
    let organizationActions = responses[13];

    return [
      ...showAllActions,
      ...operationActions,
      ...co2Actions,
      ...temperatureActions,
      ...humidifierActions,
      ...lightsActions,
      ...curtainsActions,
      ...airRailsActions,
      ...fansActions,
      ...irrigationActions,
      ...reinitializeActions,
      ...organizationActions,
      ...monitoringActions,
      ...upgradeActions,
    ]
  })
}

export const doBatchCo2Calibration = (selectedRecs) => {
  store.dispatch('batchActions/setIsBatchActionRunning', true)

  let recs = [];
  for (let i = 0; i < selectedRecs.length; i++) {
    recs.push({
      controller_id: selectedRecs[i].controller_id,
      action_id: 92,
      value: store.state.universalDashboard.co2CalibrationSettings.ppm,
      user_id: store.getters['getUser'].id,
    });
  }

  Trimaster.post("controllerCommands", store.getters['getUser'].apitoken, recs).then(
    function ([res, err]) {
      store.dispatch('batchActions/setIsBatchActionRunning', false)
      if (err) {
        vuetifyToast.error("An error occurred. Please try again later.");
      } else {
        store.dispatch('universalDashboard/setSelectedBatchAction', 0)
        vuetifyToast.success(
          "Commands were successfully added to the queue"
        );
      }
    }
  );
}

export const doBatchIrrigation = (selectedRecs) => {
  store.dispatch('batchActions/setIsBatchActionRunning', true)

  let recs = [];
  for (let i = 0; i < selectedRecs.length; i++) {
    recs.push({
      controller_id: selectedRecs[i].controller_id,
      platformGroup_id: selectedRecs[i].platformGroup_id,
      device_id: selectedRecs[i].id,
    });
  }

  Trimaster.post(
    "controllerCommands/batchIrrigate",
    store.getters['getUser'].apitoken,
    {
      platformGroups: recs,
      designator_id: store.state.universalDashboard.irrigationSettings.designator_id,
      durationSeconds: parseInt(store.state.universalDashboard.irrigationSettings.durationSeconds),
      setAutoWhenComplete: store.state.universalDashboard.irrigationSettings.setAutoWhenComplete,
    }
  ).then(function ([res, err]) {
    store.dispatch('batchActions/setIsBatchActionRunning', false)
    if (!err) {
      vuetifyToast.success("Irrigation command successfully transmitted");
    } else {
      vuetifyToast.error("An error occurred. Please try again later.");
    }
  });
}

export const doBatchBashCommand = (selectedRecs) => {
  store.dispatch('batchActions/setIsBatchActionRunning', true)

  let recs = [];
  for (let i = 0; i < selectedRecs.length; i++) {
    recs.push({
      controller_id: selectedRecs[i].controller_id,
      platformGroup_id: selectedRecs[i].platformGroup_id,
      virtualDevice_id: selectedRecs[i].id,
    });
  }

  Trimaster.post(
    "controllerCommands/doBashCommand",
    store.getters['getUser'].apitoken,
    {
      platformGroups: recs,
      id: store.state.universalDashboard.bashSettings.id,
    }
  ).then(function ([res, err]) {
    store.dispatch('batchActions/setIsBatchActionRunning', false)
    if (!err) {
      vuetifyToast.success("Bash command successfully transmitted");
    } else {
      vuetifyToast.error("An error occurred. Please try again later.");
    }
  });
}

export const doBatchIrrigationStop = (selectedRecs) => {
  store.dispatch('batchActions/setIsBatchActionRunning', true)

  let recs = [];

  for (let i = 0; i < selectedRecs.length; i++) {
    recs.push({
      controller_id: selectedRecs[i].controller_id,
      platformGroup_id: selectedRecs[i].platformGroup_id,
      device_id: selectedRecs[i].id,
    });
  }

  Trimaster.post(
    "controllerCommands/batchIrrigateStop",
    store.getters['getUser'].apitoken,
    {
      platformGroups: recs,
    }
  ).then(function ([res, err]) {
    store.dispatch('batchActions/setIsBatchActionRunning', false)
    if (!err) {
      vuetifyToast.success(
        "Stop irrigation command successfully transmitted"
      );
    } else {
      vuetifyToast.error("An error occurred. Please try again later.");
    }
  });
}

export const doBatchSetIntensity = (selectedRecs) => {
  store.dispatch('batchActions/setIsBatchActionRunning', true)

  let ids = selectedRecs.map((el) => el.controller_id);
  let platformGroupIds = selectedRecs.map((el) => el.platformGroup_id);
  Trimaster.post(
    "controllerCommands/executeComplexBatchCommand",
    store.getters['getUser'].apitoken,
    {
      controller_ids: ids,
      command: "LightOn",
      virtualDeviceType_id: 13,
      intensity: store.state.universalDashboard.intensitySettings,
    }
  ).then(function ([res, err]) {
    if (err) {
      vuetifyToast.error("Request Failed. Please try again later.");
    } else {
      vuetifyToast.success("Batch process completed!");
      store.dispatch('universalDashboard/setSelectedBatchAction', 0)
      store.dispatch('batchActions/setBatchActionLabel', {
        id: 90,
        label: 'Set Intensity'
      })
    }
    store.dispatch('batchActions/setIsBatchActionRunning', false)
  });
}

export const doBatchSetImpairedChiller = async (selectedRecs) => {
  store.dispatch('batchActions/setIsBatchActionRunning', true)

  let commands = selectedRecs.map((selected) => {
    return {
      controller_id: selected.controller_id,
      virtualDevice_id: selected.id,
      action_id: IMPAIRED_CHILLER_ACTION_ID,
      user_id: store.getters['getUser'].id,
      platformGroup_id: selected.platformGroup_id,
      value: store.state.universalDashboard.impairedChillerSettings
    };
  });

  let [res, err] = await Trimaster.post(
    "controllerCommands",
    store.getters['getUser'].apitoken,
    commands
  )

  if (err) {
    vuetifyToast.error("Request Failed. Please try again later.");
  } else {
    vuetifyToast.success("Batch process completed!");
    store.dispatch('universalDashboard/setSelectedBatchAction', 0)
    store.dispatch('batchActions/setBatchActionLabel', {
      id: IMPAIRED_CHILLER_ACTION_ID,
      label: 'Set Impaired Chill'
    })
  }
  store.dispatch('batchActions/setIsBatchActionRunning', false)
}

export const doBatchSetControlLoops = (selectedRecs) => {
  store.dispatch('batchActions/setIsBatchActionRunning', true)

  let promises = selectedRecs.map((el) => {
    Trimaster.post(
      "ControllerFsaOverrides/batchSet",
      store.getters['getUser'].apitoken,
      {
        controller_id: el.controller_id,
        virtualDeviceTypeFsa_id: store.state.universalDashboard.controlLoopSettings.map((a) => a.id),
      }
    );
  });
  Promise.all(promises).then((responses) => {
    vuetifyToast.success("Batch process completed!");
    store.dispatch('universalDashboard/setSelectedBatchAction', 0)
    store.dispatch('batchActions/setIsBatchActionRunning', false)
  });
}

export const doBatchSetDebug = (selectedRecs, logLevel) => {
  store.dispatch('batchActions/setIsBatchActionRunning', true)

  let recs = [];
  for (let i = 0; i < selectedRecs.length; i++) {
    recs.push({
      controller_id: selectedRecs[i].controller_id,
      action_id: 50,
      loglevel: logLevel,
    });
  }
  Trimaster.post("controllerCommands", store.getters['getUser'].apitoken, recs).then(
    function ([res, err]) {
      store.dispatch('batchActions/setIsBatchActionRunning', false)
      if (err) {
        vuetifyToast.error("An error occurred. Please try again later.");
      } else {
        store.dispatch('universalDashboard/setSelectedBatchAction', 0)
        vuetifyToast.success(
          "Commands were successfully added to the queue"
        );
      }
    }
  );
}

export const doRefreshSoilSensors = (selectedRecs) => {
  store.dispatch('batchActions/setIsBatchActionRunning', true)

  let recs = [];
  for (let i = 0; i < selectedRecs.length; i++) {
    recs.push({
      controller_id: selectedRecs[i].controller_id,
      action_id: 141,
    });
  }
  Trimaster.post("controllerCommands", store.getters['getUser'].apitoken, recs).then(
    function ([res, err]) {
      store.dispatch('batchActions/setIsBatchActionRunning', false)
      if (err) {
        vuetifyToast.error("An error occurred. Please try again later.");
      } else {
        store.dispatch('universalDashboard/setSelectedBatchAction', 0)
        vuetifyToast.success(
          "Commands were successfully added to the queue"
        );
      }
    }
  );
}

export const doBatchSetHeatStrip = (selectedRecs, actionId) => {
  store.dispatch('batchActions/setIsBatchActionRunning', true)

  let controllerIds = selectedRecs.map((rec) => rec.controller_id);
  Trimaster.get("virtualDevices", store.getters['getUser'].apitoken, {
    filter: {
      where: {
        controller_id: { inq: controllerIds },
        virtualDeviceType_id: 37,
      },
    },
  }).then(([results, error]) => {
    let commands = results.map((heaterStrip) => {
      return {
        controller_id: heaterStrip.controller_id,
        virtualDevice_id: heaterStrip.id,
        action_id: actionId,
        user_id: store.getters['getUser'].id,
      };
    });

    Trimaster.post(
      "controllerCommands",
      store.getters['getUser'].apitoken,
      commands
    ).then(([res, err]) => {
      if (err) {
        vuetifyToast.error("An error occurred. Please try again later.");
      } else {
        vuetifyToast.success("Commands Sent");
      }
      store.dispatch('batchActions/setIsBatchActionRunning', false)
    });
  });
}

export const onUpgradeClient = async () => {
  let selected = store.state.universalDashboard.selectedUnits;
  let controllerIds = store.state.universalDashboard.selectedUnits.length
    ? selected.map((el) => el.controller_id)
    : [store.state.universalDashboard.selectedContextMenuItem.controller_id];
  let promises = controllerIds.map((controllerId) => {
    let packet = {
      controller_id: controllerId,
      action_id: 138,
      user_id: store.getters['getUser'].id,
    };
    return Trimaster.post(
      "controllerCommands",
      store.getters['getUser'].apitoken,
      packet
    );
  });

  Promise.all(promises).then((responses) => {
    store.dispatch('universalDashboard/setSelectedContextMenuItem',  null)
    vuetifyToast.success("Client Upgraded.");
    store.dispatch('universalDashboard/setSelectedBatchAction', 0)
    store.dispatch('batchActions/setIsBatchActionRunning', false)
    EventBus.$emit('universal-dashboard-refresh')
  });
}

export const onUpgradeOS = async () => {
  let selected = store.state.universalDashboard.selectedUnits;
  let controllerIds = store.state.universalDashboard.selectedUnits.length
    ? selected.map((el) => el.controller_id)
    : [store.state.universalDashboard.selectedContextMenuItem.controller_id];
  let promises = controllerIds.map((controllerId) => {
    let packet = {
      controller_id: controllerId,
      action_id: 137,
      user_id: store.getters['getUser'].id,
    };
    return Trimaster.post(
      "controllerCommands",
      store.getters['getUser'].apitoken,
      packet
    );
  });

  Promise.all(promises).then((responses) => {
    store.dispatch('universalDashboard/setSelectedContextMenuItem',  null)
    vuetifyToast.success("OS Upgraded.");
    store.dispatch('universalDashboard/setSelectedBatchAction', 0)
    store.dispatch('batchActions/setIsBatchActionRunning', false)
    EventBus.$emit('universal-dashboard-refresh')
  });
}

export const forceSync = async () => {
  let selected = store.state.universalDashboard.selectedUnits;
  let controllerIds = store.state.universalDashboard.selectedUnits.length
    ? selected.map((el) => el.controller_id)
    : [store.state.universalDashboard.selectedContextMenuItem.controller_id];
  let promises = controllerIds.map((controllerId) => {
    return Trimaster.post("controllerCommands", store.getters['getUser'].apitoken, {
      controller_id: controllerId,
      user_id: store.getters['getUser'].id,
      action_id: FORCE_SYNC_ACTION_ID,
    });
  });

  await Promise.all(promises);

  store.dispatch('universalDashboard/setSelectedContextMenuItem',  null)
  vuetifyToast.success("Sync command sent.");
  store.dispatch('universalDashboard/setSelectedBatchAction', 0)
  store.dispatch('batchActions/setIsBatchActionRunning', false)
}
